module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }), _c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("NEW YORK UNIVERSITY PRESS")])]), _c('br'), _vm._v("New York and London")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("© 2003 by New York University")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Religion and the creation of race and ethnicity : an introduction/")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("edited by Craig R. Prentiss.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("p. cm. — (Religion, race, and ethnicity)")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Includes bibliographical references.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN 0-8147-6700-1 (cloth : alk. paper) — ISBN 0-8147-6701-X (pbk.: alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("1. Ethnicity—Religious aspects.   I. Prentiss, Craig R.   II. Series.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("BL65.E75 R47 2003")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("291.1’78348—dc21      2002152479")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("New York University Press books are printed on acid-free paper,")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("and their binding materials are chosen for strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99c55960","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 69
// module chunks = 0